var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBabySleepIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 55,
    viewBox: "0 0 62 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 318",
    width: 62,
    height: 55,
    rx: 10,
    fill: "#FFB95F",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "People"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sleep_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35__2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31__10_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27.3765 16.2471C17.2377 16.2471 9 24.4848 9 34.6236M9 34.6236C9 32.7225 9 36.8414 9 34.6236ZM9 34.6236C9 44.7623 17.2377 53.0001 27.3765 53.0001C37.5152 53.0001 45.753 44.7623 45.753 34.6236C45.753 32.7225 45.4361 30.8215 44.8025 28.9205",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M45.5945 34.6239C45.5945 27.3367 41.3172 21 35.2974 18.1484",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M16.1284 33.832H22.6236",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M32.1289 33.832H38.4656",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M33.7134 44.763C34.1886 44.4462 34.6639 44.1293 35.2976 43.8125",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    d: "M29.2773 46.1887C30.8615 46.0303 32.2873 45.3966 33.8715 44.6045",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    d: "M19.2974 43.8125C22.6241 45.8719 25.9509 46.8224 29.2777 46.3472",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    d: "M32.9215 49.3574C32.9215 49.9911 32.4462 50.4663 31.8125 50.4663C31.1789 50.4663 30.7036 49.9911 30.7036 49.3574",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    d: "M29.2773 46.1885C30.3863 47.139 30.8615 48.2479 30.7031 49.1984",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10",
    d: "M33.8715 44.6045C33.0794 46.3471 32.6042 47.9313 32.921 49.357",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11",
    d: "M30.0693 14.9805H33.8714",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12",
    d: "M29.5942 18.1494H33.3963",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13",
    d: "M29.5942 18.1488L33.8715 14.9805",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14",
    d: "M37.6733 10.0703H43.5348",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15",
    d: "M36.8813 15.1396H42.426",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16",
    d: "M36.8813 15.1397L43.5349 10.0703",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17",
    d: "M47.0205 5H53.8325",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18",
    d: "M45.9111 11.0195H52.7231",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19",
    d: "M45.9111 11.0199L53.832 5",
    stroke: "#FFA726",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabySleepIcon);
export default __webpack_public_path__ + "static/media/baby-sleep-icon.0346df5e091dd67622035139899a3f3b.svg";
export { ForwardRef as ReactComponent };